import zodToJsonSchema from 'zod-to-json-schema';

function makeFieldSchemaFromZod(returnSchema, uiOptionsSchema) {
  return {
    schema: {
      returnValue: zodToJsonSchema(returnSchema),
      uiOptions: uiOptionsSchema ? zodToJsonSchema(uiOptionsSchema) : void 0
    },
    type: null,
    uiOptionsType: null,
    TProps: void 0
  };
}

export { makeFieldSchemaFromZod };
//# sourceMappingURL=utils.esm.js.map
